import { render, staticRenderFns } from "./Broker.vue?vue&type=template&id=dcd44c5c"
import script from "./Broker.vue?vue&type=script&lang=ts"
export * from "./Broker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports